/* unplugin-vue-components disabled */import { render } from "./bindRole.vue?vue&type=template&id=af075d3e&scoped=true"
import script from "./bindRole.vue?vue&type=script&lang=js"
export * from "./bindRole.vue?vue&type=script&lang=js"

import "./bindRole.vue?vue&type=style&index=0&id=af075d3e&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/e-bike/e-bike-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af075d3e"]])

export default __exports__